export default function selectRoleField(data) {
  return data?.role;
}
